document.addEventListener('DOMContentLoaded', async () => {

  const calibrationIds = [
    '16395534532957',
    '16395534696797'
  ];

  const page = document.querySelector('.pl4-quote-page');
  if (!page) return;

  const $ = id => document.getElementById(id);

  const language =
    String(
      page.dataset.pl4Lang ||
      document.documentElement.lang ||
      'fr'
    ).toLowerCase();

  const isEn = language.startsWith('en');
  const locale = isEn ? 'en-US' : 'fr-FR';

  const i18n = {
    noProduct: isEn ? 'No product found.' : 'Aucun produit trouvé.',
    ref: isEn ? 'Ref.' : 'Réf.',
    catalogNotFound: isEn
      ? 'Product catalogue not found'
      : 'Catalogue produits introuvable',
    productNotFound: isEn
      ? 'Product not found'
      : 'Produit introuvable'
  };

  const rawRoot =
    page.dataset.pl4Root ||
    window.Shopify?.routes?.root ||
    '/';

  const root =
    rawRoot === '/'
      ? '/'
      : `${String(rawRoot).replace(/\/+$/, '')}/`;

  const params = new URLSearchParams(location.search);
  const successReturn = params.get('devis') === 'envoye';

  let productId = params.get('product_id');
  let handle = params.get('product'); // Compatibilité avec les anciens liens.
  let variantId = params.get('variant');
  let productCatalog = [];

  const form = $('PL4QuoteForm');
  const selectorBox = $('pl4-product-selector');
  const searchInput = $('PL4ProductSearch');
  const searchResults = $('PL4ProductResults');
  const summary = $('pl4-product-summary');
  const calibration = $('pl4-calibration-block');
  const success = $('pl4-quote-success');


  /* ORDRE DES PRODUITS — COLLECTION HOMEPAGE ID 720426238301 */

  let homepageProductOrder = [];

  try {
    const homepageOrderNode = $('PL4HomepageOrder');
    const parsedOrder = JSON.parse(
      homepageOrderNode?.textContent || '[]'
    );

    if (Array.isArray(parsedOrder)) {
      homepageProductOrder = parsedOrder
        .map(value => String(value || '').trim())
        .filter(Boolean);
    }
  } catch (_) {}

  const homepageProductOrderIndex =
    new Map(
      homepageProductOrder.map(
        (productHandle, index) => [productHandle, index]
      )
    );

  function compareProductsByHomepageOrder(a, b) {
    const aHandle = String(a?.handle || '');
    const bHandle = String(b?.handle || '');

    const aInHomepage =
      homepageProductOrderIndex.has(aHandle);

    const bInHomepage =
      homepageProductOrderIndex.has(bHandle);

    if (aInHomepage && bInHomepage) {
      return (
        homepageProductOrderIndex.get(aHandle) -
        homepageProductOrderIndex.get(bHandle)
      );
    }

    if (aInHomepage) return -1;
    if (bInHomepage) return 1;

    return formatProductTitle(a?.title).localeCompare(
      formatProductTitle(b?.title),
      locale,
      { sensitivity: 'base' }
    );
  }

  const hidden = {
    product: $('pl4-hidden-product'),
    productId: $('pl4-hidden-product-id'),
    variant: $('pl4-hidden-variant'),
    variantId: $('pl4-hidden-variant-id'),
    sku: $('pl4-hidden-sku'),
    url: $('pl4-hidden-product-url')
  };


  /* RESTAURATION APRÈS ENVOI */

  if (!handle && !productId && successReturn) {
    try {
      const saved = JSON.parse(
        sessionStorage.getItem('pl4QuoteProduct')
      );

      if (saved?.productId) {
        productId = String(saved.productId);
        handle = saved.handle || '';
        variantId = saved.variantId || '';
      } else if (saved?.handle) {
        handle = saved.handle;
        variantId = saved.variantId || '';
      }
    } catch (_) {}
  }


  function normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase();
  }


  function formatProductTitle(value) {
    let title = String(value || '')
      .trim()
      .replace(/\s+/g, ' ')
      .toLocaleLowerCase(locale);

    if (!title) return '';

    title =
      title.charAt(0).toLocaleUpperCase(locale) +
      title.slice(1);

    return title
      .replace(/\bprolaser\b/gi, 'ProLaser')
      .replace(/\blidar\b/gi, 'LIDAR')
      .replace(/\bip67\b/gi, 'IP67')
      .replace(/\bpdf\b/gi, 'PDF');
  }


  function resetProduct() {
    summary.hidden = true;
    calibration.hidden = true;

    $('pl4-product-variant-row').hidden = true;
    $('pl4-product-sku-row').hidden = true;
    $('pl4-product-price-row').hidden = true;
    $('pl4-included-case').hidden = true;

    document
      .querySelectorAll('[data-calibration-field]')
      .forEach(el => el.required = false);
  }


  function setCalibration(product, variant) {

    const active = [
      String(product.id || ''),
      String(variant?.id || '')
    ].some(id => calibrationIds.includes(id));

    calibration.hidden = !active;

    $('QuoteSerial').required = active;

    document
      .querySelectorAll(
        'input[name="contact[Type de ProLaser]"]'
      )
      .forEach(el => el.required = active);

    return active;
  }


  async function loadProductCatalog() {

    if (productCatalog.length) {
      return productCatalog;
    }

    const response =
      await fetch(`${root}products.json?limit=250`);

    if (!response.ok) {
      throw new Error(i18n.catalogNotFound);
    }

    const data = await response.json();

    productCatalog =
      (data.products || [])
        .sort(compareProductsByHomepageOrder);

    return productCatalog;
  }


  async function findProductById(requestedProductId) {

    if (!requestedProductId) return null;

    const catalog = await loadProductCatalog();

    return (
      catalog.find(
        product =>
          String(product?.id || '') ===
          String(requestedProductId)
      ) || null
    );
  }


  async function fetchProduct(productHandle) {

    const response = await fetch(
      `${root}products/${encodeURIComponent(productHandle)}.js`
    );

    if (!response.ok) {
      throw new Error(i18n.productNotFound);
    }

    return response.json();
  }


  async function showProduct(productHandle, requestedVariant = '') {

    const product = await fetchProduct(productHandle);

    const variant =
      product.variants?.find(
        v => String(v.id) === String(requestedVariant)
      ) ||
      product.variants?.[0] ||
      null;

    resetProduct();


    /* IMAGE */

    const image =
      variant?.featured_image?.src ||
      product.featured_image ||
      product.images?.[0] ||
      '';

    const imageWrap =
      document.querySelector('.pl4-product-image-wrap');

    if (image) {
      $('pl4-product-image').src = image;
      $('pl4-product-image').alt = product.title;
      imageWrap.style.display = '';
    } else {
      imageWrap.style.display = 'none';
    }


    /* TITRE */

    $('pl4-product-title').textContent = product.title;


    /* VARIANTE */

    if (
      variant?.title &&
      variant.title !== 'Default Title'
    ) {
      $('pl4-product-variant').textContent = variant.title;
      $('pl4-product-variant-row').hidden = false;
    }


    /* SKU */

    if (variant?.sku) {
      $('pl4-product-sku').textContent = variant.sku;
      $('pl4-product-sku-row').hidden = false;
    }


    /* PRIX */

    if (Number(variant?.price) > 0) {

      const currency =
        window.Shopify?.currency?.active ||
        'EUR';

      try {
        $('pl4-product-price').textContent =
          new Intl.NumberFormat(
            locale,
            {
              style: 'currency',
              currency
            }
          ).format(variant.price / 100);

        $('pl4-product-price-row').hidden = false;
      } catch (_) {}
    }


    /* URL */

    let productUrl =
      `${location.origin}${root}products/${product.handle}`;

    if (variant?.id) {
      productUrl += `?variant=${variant.id}`;
    }

    $('pl4-product-link').href = productUrl;


    /* ÉTALONNAGE */

    const isCalibration =
      setCalibration(product, variant);

    /* MALLETTE INCLUSE - UNIQUEMENT PROLASER 4 ET PROLASER 4 EXPORT */

    const hasIncludedCase = [
      '16395533222237',
      '16395534434653'
    ].includes(String(product.id || ''));

    if (hasIncludedCase) {
      $('pl4-included-case').hidden = false;
    }


    /* CHAMPS CACHÉS */

    hidden.product.value = product.title || '';
    hidden.productId.value = product.id || '';

    hidden.variant.value =
      variant?.title &&
      variant.title !== 'Default Title'
        ? variant.title
        : '';

    hidden.variantId.value = variant?.id || '';
    hidden.sku.value = variant?.sku || '';
    hidden.url.value = productUrl;


    summary.hidden = false;

    productId = String(product.id || '');
    handle = product.handle;
    variantId = variant?.id || '';


    /* SYNCHRONISE LA RECHERCHE */

    if (searchInput) {
      searchInput.value = formatProductTitle(product.title);
    }


    try {
      sessionStorage.setItem(
        'pl4QuoteProduct',
        JSON.stringify({
          productId,
          handle,
          variantId
        })
      );
    } catch (_) {}
  }


  function hideSearchResults() {
    if (!searchResults) return;

    searchResults.hidden = true;

    if (searchInput) {
      searchInput.setAttribute('aria-expanded', 'false');
    }
  }


  function renderSearchResults(query = '') {

    if (!searchResults || !searchInput) return;

    const term = normalize(query);

    const matches = productCatalog
      .filter(product => {

        const firstVariant =
          product.variants?.[0] || {};

        const haystack = normalize([
          product.title,
          product.handle,
          firstVariant.sku
        ].join(' '));

        return !term || haystack.includes(term);

      })
      .slice(0, 20);

    searchResults.innerHTML = '';

    if (!matches.length) {
      const empty = document.createElement('div');
      empty.className = 'pl4-product-result-empty';
      empty.textContent = i18n.noProduct;
      searchResults.appendChild(empty);
      searchResults.hidden = false;
      searchInput.setAttribute('aria-expanded', 'true');
      return;
    }

    matches.forEach(product => {

      const button =
        document.createElement('button');

      button.type = 'button';
      button.className = 'pl4-product-result';
      button.setAttribute('role', 'option');

      const image =
        product.images?.[0]?.src ||
        product.images?.[0] ||
        '';

      if (image) {
        const img = document.createElement('img');
        img.src = image;
        img.alt = '';
        img.loading = 'lazy';
        button.appendChild(img);
      } else {
        const placeholder = document.createElement('span');
        placeholder.className = 'pl4-product-result-placeholder';
        placeholder.textContent = 'PL4';
        button.appendChild(placeholder);
      }

      const copy =
        document.createElement('span');

      copy.className = 'pl4-product-result-copy';

      const title =
        document.createElement('strong');

      title.textContent =
        formatProductTitle(product.title);

      copy.appendChild(title);

      const sku =
        product.variants?.[0]?.sku;

      if (sku) {
        const meta =
          document.createElement('small');

        meta.textContent = `${i18n.ref} ${sku}`;
        copy.appendChild(meta);
      }

      button.appendChild(copy);

      button.addEventListener('click', async () => {

        searchInput.value =
          formatProductTitle(product.title);

        hideSearchResults();

        try {
          await showProduct(product.handle);

          summary.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });

        } catch (error) {
          console.error(error);
        }

      });

      searchResults.appendChild(button);

    });

    searchResults.hidden = false;
    searchInput.setAttribute('aria-expanded', 'true');
  }


  async function buildProductSearch() {

    selectorBox.hidden = false;

    if (selectorBox.dataset.ready === 'true') {
      return;
    }

    try {

      await loadProductCatalog();

      selectorBox.dataset.ready = 'true';


      searchInput.addEventListener('focus', () => {

        if (handle) {
          /* Un produit est déjà sélectionné :
            on réaffiche toute la liste pour pouvoir en changer */
          renderSearchResults('');
        } else {
          renderSearchResults(searchInput.value);
        }

      });


      searchInput.addEventListener('input', () => {

        productId = '';
        handle = '';
        variantId = '';

        resetProduct();

        renderSearchResults(searchInput.value);
      });


      searchInput.addEventListener('keydown', event => {

        if (event.key === 'Escape') {
          hideSearchResults();
          return;
        }

        if (event.key === 'Enter') {

          const firstResult =
            searchResults.querySelector('.pl4-product-result');

          if (firstResult) {
            event.preventDefault();
            firstResult.click();
          }
        }
      });


      document.addEventListener('click', event => {

        if (!selectorBox.contains(event.target)) {
          hideSearchResults();
        }
      });

    } catch (error) {
      console.error(error);
    }
  }


  /* INITIALISATION */

  if (productId) {

    try {
      const matchedProduct =
        await findProductById(productId);

      if (!matchedProduct?.handle) {
        throw new Error(i18n.productNotFound);
      }

      await showProduct(
        matchedProduct.handle,
        variantId
      );

    } catch (_) {
      productId = '';
      handle = '';
      await buildProductSearch();
    }

  } else if (handle) {

    try {
      await showProduct(handle, variantId);
    } catch (_) {
      handle = '';
      await buildProductSearch();
    }

  } else {

    if (!successReturn) {
      try {
        sessionStorage.removeItem('pl4QuoteProduct');
      } catch (_) {}
    }

    await buildProductSearch();
  }


  /* ENVOI */

  form?.addEventListener('submit', event => {

    if (!handle) {

      event.preventDefault();

      selectorBox.hidden = false;

      searchInput.focus();
      renderSearchResults(searchInput.value);

      const y =
        selectorBox.getBoundingClientRect().top +
        window.scrollY -
        120;

      window.scrollTo({
        top: Math.max(0, y),
        behavior: 'smooth'
      });

      return;
    }

    try {
      sessionStorage.setItem(
        'pl4QuoteProduct',
        JSON.stringify({
          productId,
          handle,
          variantId
        })
      );
    } catch (_) {}

  });


  /* CONFIRMATION APRÈS RETOUR DU PHP */

  if (successReturn && success) {

    success.hidden = false;

    setTimeout(() => {

      const y =
        success.getBoundingClientRect().top +
        window.scrollY -
        150;

      success.focus({
        preventScroll: true
      });

      window.scrollTo({
        top: Math.max(0, y),
        behavior: 'smooth'
      });

    }, 450);

    setTimeout(() => {
      const cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete('devis');

      window.history.replaceState(
        {},
        '',
        cleanUrl.pathname + cleanUrl.search + cleanUrl.hash
      );
    }, 1200);
  }

});